const PREVIEW_KEY = "hayat-arabic-preview";

export const clearArabicPreview = () => {
  if (typeof window === "undefined") return;
  try { window.sessionStorage.removeItem(PREVIEW_KEY); } catch { /* best effort */ }

  const url = new URL(window.location.href);
  if (url.searchParams.get("preview") === "ar") {
    url.searchParams.delete("preview");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  }
};

export const isArabicPreview = () => {
  if (typeof window === "undefined") return false;
  const requested = new URLSearchParams(window.location.search).get("preview");
  if (requested === "ar") {
    try { window.sessionStorage.setItem(PREVIEW_KEY, "1"); } catch { /* best effort */ }
    return true;
  }
  if (requested === "off") {
    clearArabicPreview();
    return false;
  }
  try { return window.sessionStorage.getItem(PREVIEW_KEY) === "1"; } catch { return false; }
};
